<dialog-base [width]="40" [height]="25" [isError]="false">
    <div header-slot>Wymagana akceptacja regulaminu</div>
    <div content-slot>
      <div>Konieczne jest zapoznanie się i akceptacja aktualnych regulaminów promocji:</div>
      &nbsp;
      <div class="login-form-input-description-container">
        <span id="pdfDownload" (click)="downloadPdf('regulamin_promocji_klimatyzacja')">Regulamin promocji "Klimatyzacja Panasonic"</span>
      </div>
      &nbsp;
      <div class="login-form-input-description-container">
        <span id="pdfDownload" (click)="downloadPdf('regulamin_promocji_pomp_ciepła')">Regulamin promocji "Pompy Ciepła Panasonic"</span>
      </div>
      &nbsp;
      <div class="login-form-input-description-container">
        <div class="checkbox-container">
          <label>
            <input type="checkbox" value="false" (change)="toggleAirconditionCheckBox($event)">
            <span>Potwierdzam zapoznanie się z regulaminami</span>
          </label>
        </div>
        <!-- <span *ngIf="!termsCheckbox"
        class="input-error">W celu rejestracji potwierdź zapoznanie się z regulaminem</span> -->
      </div>
    </div>
    <div footer-slot class="dialog-buttons-container">
      <button type="button" class="btn btn-primary btn-primary-custom" [disabled]="!StatutesChecks" (click)="confirm()">Ok</button>
      <button type="button" class="btn btn-secondary btn-secondary-custom" (click)="cancel()">Anuluj</button>
    </div>
  </dialog-base>
